import { useState } from "react";
import { http, formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Newsletter({ flush = false, compact = false }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await http.post("/newsletter/subscribe", { email });
      toast.success(data?.message || "Subscribed");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not subscribe.");
    } finally {
      setLoading(false);
    }
  };

  if (compact) {
    return (
      <form onSubmit={onSubmit} className="mt-6 max-w-sm" data-testid="footer-newsletter-form">
        <p className="overline overline-gold mb-3">The Sunday dispatch</p>
        <p className="text-sm text-[#f8f4ec]/70 mb-3">One letter, one tea, every Sunday morning. No spam.</p>
        <div className="flex gap-2">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            className="flex-1 min-w-0 h-10 rounded-full border border-[#f8f4ec]/25 bg-[#f8f4ec]/10 px-4 text-sm text-[#f8f4ec] placeholder:text-[#f8f4ec]/50 outline-none focus:border-[#c9a45c] transition-colors"
            data-testid="footer-newsletter-email-input"
          />
          <button
            type="submit"
            disabled={loading}
            className="btn-paper !py-0 h-10 !px-4 !text-[10px] disabled:opacity-60"
            data-testid="footer-newsletter-submit-button"
          >
            {loading ? "…" : "Subscribe"}
          </button>
        </div>
      </form>
    );
  }

  return (
    <section
      className={`${flush ? "" : "mt-16"} py-16 md:py-20 px-6 md:px-12 band-navy border-t border-[#f8f4ec]/10`}
      data-testid="newsletter-section"
    >
      <div className="max-w-3xl mx-auto text-center">
        <p className="overline overline-gold justify-center mb-5">The Tea List dispatch</p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light tracking-tight leading-[1.05]">
          One letter. One tea.
          <br />
          Every Sunday morning.
        </h2>
        <p className="mt-6 text-base md:text-lg font-light text-[#f8f4ec]/75 max-w-xl mx-auto">
          Slow reading for slow drinkers. No spam,
          unsubscribe in a single click.
        </p>
        <form
          onSubmit={onSubmit}
          className="mt-10 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
        >
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            required
            className="flex-1 min-h-12 rounded-full border border-[#f8f4ec]/25 bg-[#f8f4ec]/10 px-5 text-[#f8f4ec] placeholder:text-[#f8f4ec]/55 outline-none focus:border-[#c9a45c] transition-colors"
            data-testid="newsletter-email-input"
          />
          <button
            type="submit"
            disabled={loading}
            className="btn-paper disabled:opacity-60"
            data-testid="newsletter-submit-button"
          >
            {loading ? "Sending…" : "Subscribe →"}
          </button>
        </form>
      </div>
    </section>
  );
}
